import { StepState } from '@vmware-react/vrlcm';
import { EnvironmentRequestProduct } from 'vrlcm-gui-types';
import * as Constants from '../../constants/action-constants';
import { UpgradeState } from '../../types/workflows/UpgradeWorkflow';

export interface InitializeUpgradeWorkflow {
  type: Constants.INITIALIZE_UPGRADE_WORKFLOW;
  payload: {
    requestId: string;
  };
}

export interface InitializeUpgradeWorkflowSuccess {
  type: Constants.INITIALIZE_UPGRADE_WORKFLOW_SUCCESS;
  payload: {
    state: UpgradeState;
    existingVidm?: EnvironmentRequestProduct;
  };
}

export interface InitializeUpgradeWorkflowFailed {
  type: Constants.INITIALIZE_UPGRADE_WORKFLOW_FAILED;
}

export interface UpdateUpgradeStepStates {
  type: Constants.UPDATE_UPGRADE_STEP_STATES;
  payload: {
    stepStates: StepState[];
  };
}

export interface SaveUpgradeWorkflow {
  type: Constants.SAVE_UPGRADE_WORKFLOW;
  payload: {
    state: UpgradeState;
    exit?: boolean;
  };
}

export interface SaveUpgradeWorkflowSuccess {
  type: Constants.SAVE_UPGRADE_WORKFLOW_SUCCESS;
  payload: {
    state: UpgradeState;
  };
}

export interface SaveUpgradeWorkflowFailed {
  type: Constants.SAVE_UPGRADE_WORKFLOW_FAILED;
}

export interface SubmitUpgradeWorkflow {
  type: Constants.SUBMIT_UPGRADE_WORKFLOW;
  payload: {
    state: UpgradeState;
  };
}

export interface SubmitUpgradeWorkflowSuccess {
  type: Constants.SUBMIT_UPGRADE_WORKFLOW_SUCCESS;
}

export interface SubmitUpgradeWorkflowFailed {
  type: Constants.SUBMIT_UPGRADE_WORKFLOW_FAILED;
}

export type UpgradeWorkflowAction =
  | InitializeUpgradeWorkflow
  | InitializeUpgradeWorkflowFailed
  | InitializeUpgradeWorkflowSuccess
  | UpdateUpgradeStepStates
  | SaveUpgradeWorkflow
  | SaveUpgradeWorkflowFailed
  | SaveUpgradeWorkflowSuccess
  | SubmitUpgradeWorkflow
  | SubmitUpgradeWorkflowFailed
  | SubmitUpgradeWorkflowSuccess;

export const initializeUpgradeWorkflow = (
  requestId: string
): InitializeUpgradeWorkflow => ({
  type: Constants.INITIALIZE_UPGRADE_WORKFLOW,
  payload: { requestId }
});

export const initializeUpgradeWorkflowSuccess = (
  state: UpgradeState,
  existingVidm?: EnvironmentRequestProduct
): InitializeUpgradeWorkflowSuccess => ({
  type: Constants.INITIALIZE_UPGRADE_WORKFLOW_SUCCESS,
  payload: { state, existingVidm }
});

export const initializeUpgradeWorkflowFailed = (): InitializeUpgradeWorkflowFailed => ({
  type: Constants.INITIALIZE_UPGRADE_WORKFLOW_FAILED
});

export const updateUpgradeStepStates = (
  stepStates: StepState[]
): UpdateUpgradeStepStates => ({
  type: Constants.UPDATE_UPGRADE_STEP_STATES,
  payload: { stepStates }
});

export const saveUpgradeWorkflow = (
  state: UpgradeState,
  exit?: boolean
): SaveUpgradeWorkflow => ({
  type: Constants.SAVE_UPGRADE_WORKFLOW,
  payload: { state, exit }
});

export const saveUpgradeWorkflowSuccess = (
  state: UpgradeState
): SaveUpgradeWorkflowSuccess => ({
  type: Constants.SAVE_UPGRADE_WORKFLOW_SUCCESS,
  payload: { state }
});

export const saveUpgradeWorkflowFailed = (): SaveUpgradeWorkflowFailed => ({
  type: Constants.SAVE_UPGRADE_WORKFLOW_FAILED
});

export const submitUpgradeWorkflow = (
  state: UpgradeState
): SubmitUpgradeWorkflow => ({
  type: Constants.SUBMIT_UPGRADE_WORKFLOW,
  payload: { state }
});

export const submitUpgradeWorkflowSuccess = (): SubmitUpgradeWorkflowSuccess => ({
  type: Constants.SUBMIT_UPGRADE_WORKFLOW_SUCCESS
});

export const submitUpgradeWorkflowFailed = (): SubmitUpgradeWorkflowFailed => ({
  type: Constants.SUBMIT_UPGRADE_WORKFLOW_FAILED
});
